import "./App.css";
import { Routes, Route, Navigate } from "react-router-dom";
import CertificateCard from "./CertificateCard";

function App() {
  return (
    <Routes>
      <Route path="/" element={<CertificateCard />} />
      <Route path="/get-certificate/:id" element={<CertificateCard />} />
    </Routes>
  );
}

export default App;
